import React, { useState, useContext, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { EMAIL_TEMPLATE_API } from 'src/views/utils/urls'
import { checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { AppContext } from 'src/views/context/app'
import {
  CRow,
  CCol,
  CButton,
  CFormLabel,
  CFormInput,
  CFormSelect,
  CFormTextarea,
} from '@coreui/react'

function AddTemplate() {
  const [html, setHtml] = useState('')
  const [name, setName] = useState('')
  const [subject, setSubject] = useState('')
  const { setLoader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const history = useHistory()
  const location = useLocation()
  const [flag, setFlag] = useState(false)
  const [templateId, setTemplateId] = useState('')
  const [selectedOption, setSelectedOption] = useState(null)

  useEffect(() => {
    if (location.search) {
      const query_params = location.search
      const search_params = new URLSearchParams(query_params)
      setTemplateId(search_params.get('email_template_id'))
      setFlag(true)
      templateInformationCall({
        params: {
          email_template_id: templateId,
        },
      })
      console.log('api called', templateInformationLoading)
    }
  }, [location, templateId])

  const isCreateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.EMAIL_TEMPLATE.CREATE,
  )

  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.EMAIL_TEMPLATE.UPDATE,
  )

  const [
    { data: templateInformation, loading: templateInformationLoading },
    templateInformationCall,
  ] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createTemplate, loading: createTemplateLoading }, templateCreateCall] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateTemplate, loading: updateTemplateLoading }, templateUpdateCall] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(createTemplateLoading || updateTemplateLoading || templateInformationLoading)
  }, [createTemplateLoading, updateTemplateLoading, templateInformationLoading])

  useEffect(() => {
    if (createTemplate && createTemplate.success) {
      raiseToast('success', 'Template added successfully')
      history.push('/email-template')
    }
  }, [createTemplate])

  useEffect(() => {
    console.log(updateTemplate)
    if (updateTemplate && updateTemplate.success) {
      raiseToast('success', 'Template edited successfully')
      history.push('/email-template')
    }
  }, [updateTemplate])

  useEffect(() => {
    if (templateInformation && templateInformation.success) {
      raiseToast('success', 'Template Information loaded.')
      setHtml(templateInformation.data.body)
      setSubject(templateInformation.data.subject)
      setName(templateInformation.data.name)
      setSelectedOption(templateInformation.data.template_type)
    }
  }, [templateInformation])

  const newTemplate = (payload) => {
    console.log(payload)
    templateCreateCall({
      data: payload,
    })
  }

  const editTemplate = (payload, id) => {
    templateUpdateCall({
      params: {
        email_template_id: id,
      },
      data: payload,
    })
  }

  const handleAdd = () => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    const payload = {
      name: name,
      subject: subject,
      body: html,
      template_type: selectedOption,
    }
    newTemplate(payload)
  }

  const handleHtmlChange = (event) => {
    setHtml(event.target.value)
  }

  const handleNameChange = (event) => {
    setName(event.target.value)
  }

  const handleSubjectChange = (event) => {
    setSubject(event.target.value)
  }

  const handleEdit = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    const payload = {
      name: name,
      subject: subject,
      body: html,
      template_type: selectedOption,
    }
    editTemplate(payload, templateId)
  }

  const handleSelect = (event) => {
    setSelectedOption(event.target.value)
  }

  const handleSubmit = () => {
    if (flag) {
      handleEdit()
    } else {
      handleAdd()
    }
  }

  // You can fetch options from an API or any other data source here
  const options = [
    { value: 'FORGOT_PASSWORD', label: 'Forgot Password' },
    { value: 'REGISTER', label: 'Register' },
    { value: 'VERIFY_EMAIL', label: 'Verify Email' },
    { value: 'SUBSCRIPTION', label: 'Subscription' },
  ]

  return (
    <div className="container-fluid mt-5">
      <div className="row">
        <div className="col-md-6">
          <div className="card p-4">
            <h2 className="text-center mb-4">Email Template Editor</h2>
            <CRow className="mt-4">
              <CCol lg="12">
                <CFormLabel>Name</CFormLabel>
                <CFormInput type="text" value={name} name="name" onChange={handleNameChange} />
              </CCol>
            </CRow>
            <CRow className="mt-4">
              <CCol lg="12">
                <CFormLabel>Select Template Type</CFormLabel>
                <CFormSelect onChange={handleSelect} value={selectedOption}>
                  <option value=" "></option>
                  {options.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
            </CRow>
            <CRow className="mt-4">
              <CCol lg="12">
                <CFormLabel>Subject</CFormLabel>
                <CFormInput
                  type="text"
                  id="subject"
                  className="form-control"
                  value={subject}
                  onChange={handleSubjectChange}
                />
              </CCol>
            </CRow>
            <CRow className="mt-4">
              <CCol lg="12">
                <CFormLabel>HTML Editor</CFormLabel>
                <CFormTextarea
                  type="text"
                  id="html-editor"
                  className="form-control"
                  value={html}
                  onChange={handleHtmlChange}
                  rows={12}
                  cols={50}
                />
              </CCol>
            </CRow>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card p-4 preview-card">
            <h2 className="text-center mb-4">Preview</h2>
            <div className="preview-content" style={{ height: '640px', overflowY: 'scroll' }}>
              {
                <>
                  <div className="preview-name mb-2">
                    <strong>Name:</strong> {name}
                  </div>
                  <div className="preview-subject mb-2">
                    <strong>Subject:</strong> {subject}
                  </div>
                  <div className="preview-html" dangerouslySetInnerHTML={{ __html: html }} />
                </>
              }
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', height: '100px' }}
      >
        <CButton onClick={handleSubmit}>Submit</CButton>
      </div>
    </div>
  )
}

export default AddTemplate
